var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval53BError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 88 42",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M14 28c0-7.732 6.268-14 14-14h32c7.732 0 14 6.268 14 14s-6.268 14-14 14H28c-7.732 0-14-6.268-14-14Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M60 16H28c-6.627 0-12 5.373-12 12s5.373 12 12 12h32c6.627 0 12-5.373 12-12s-5.373-12-12-12Zm-32-2c-7.732 0-14 6.268-14 14s6.268 14 14 14h32c7.732 0 14-6.268 14-14s-6.268-14-14-14H28Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M44 11c-3.314 0-6-2.239-6-5s2.686-5 6-5 6 2.239 6 5-2.686 5-6 5Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M49 6c0-2.046-2.06-4-5-4s-5 1.954-5 4v1a1 1 0 1 1-2 0V6c0-3.477 3.313-6 7-6 3.688 0 7 2.523 7 6v1a1 1 0 0 1-2 0V6Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M61 11c-3.314 0-6-2.239-6-5s2.686-5 6-5 6 2.239 6 5-2.686 5-6 5Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M66 6c0-2.046-2.06-4-5-4s-5 1.954-5 4v1a1 1 0 1 1-2 0V6c0-3.477 3.313-6 7-6 3.688 0 7 2.523 7 6v1a1 1 0 0 1-2 0V6Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M27 11c-3.314 0-6-2.239-6-5s2.686-5 6-5 6 2.239 6 5-2.686 5-6 5Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M32 6c0-2.046-2.06-4-5-4s-5 1.954-5 4v1a1 1 0 1 1-2 0V6c0-3.477 3.313-6 7-6 3.688 0 7 2.523 7 6v1a1 1 0 0 1-2 0V6Z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M11 28c0 3.314-2.239 6-5 6s-5-2.686-5-6 2.239-6 5-6 5 2.686 5 6Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M6 23c-2.046 0-4 2.06-4 5s1.954 5 4 5h1a1 1 0 1 1 0 2H6c-3.477 0-6-3.313-6-7 0-3.688 2.523-7 6-7h1a1 1 0 0 1 0 2H6Z",
  clipRule: "evenodd"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M77 28c0-3.314 2.239-6 5-6s5 2.686 5 6-2.239 6-5 6-5-2.686-5-6Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M82 33c2.046 0 4-2.06 4-5s-1.954-5-4-5h-1a1 1 0 1 1 0-2h1c3.477 0 6 3.313 6 7 0 3.688-2.523 7-6 7h-1a1 1 0 1 1 0-2h1Z",
  clipRule: "evenodd"
})));
SvgOval53BError.viewBox = '0 0 88 42';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval53BError);
export default ForwardRef;